/**
 * video-modal.js
 * Módulo para el modal de reproducción de highlights de YouTube.
 * Usa delegación de eventos — sin handlers inline — para ser CSP-compliant.
 */

export function setupVideoModal() {
  const overlay  = document.getElementById('videoModalOverlay');
  const iframe   = document.getElementById('videoModalIframe');
  const titleEl  = document.getElementById('videoModalTitle');
  const closeBtn = document.getElementById('videoModalClose');

  if (!overlay || !iframe || !closeBtn) return;

  // ── Abrir ──────────────────────────────────────────────────────────────────
  function openModal(videoId, videoTitle) {
    titleEl.innerHTML = '<i class="fas fa-film"></i> ' + (videoTitle || 'Mejores Jugadas');
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  // ── Cerrar ─────────────────────────────────────────────────────────────────
  function closeModal() {
    overlay.classList.remove('is-open');
    // Vaciar src detiene el audio/video del iframe
    iframe.src = '';
    document.body.style.overflow = '';
  }

  // ── Delegación de eventos (captura clics en botones generados dinámicamente) ──
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-open-video');
    if (btn) {
      openModal(btn.dataset.videoId, btn.dataset.videoTitle);
    }
  });

  // ── Cerrar con botón ×, clic en overlay y tecla Escape ────────────────────
  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });
}
